/*!
 * Copyright 2019 Fondazione Bruno Kessler
 * Licensed under the EUPL, Version 1.1 or - as soon they will be approved by the European
 * Commission - subsequent versions of the EUPL (the "Licence"); You may not use this work
 * except in compliance with the Licence.
 *
 * You may obtain a copy of the Licence at:
 * http://ec.europa.eu/idabc/eupl.html
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the Licence is distributed on an "AS IS" basis, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the Licence for the specific language
 * governing permissions and limitations under the Licence.
 */

import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";

/**
 * Intercept naviagation and redirect user to an external site.
 * External site must be declared in "path" query param.
 *
 * @export
 */
@Injectable({
  providedIn: "root",
})
export class ExternalProviderResolver implements Resolve<void> {
  resolve(
    route: ActivatedRouteSnapshot,
    _: RouterStateSnapshot
  ): void | Observable<void> | Promise<void> {
    // Get "path" query param
    const path = route.queryParamMap.get("path");
    const target = route.queryParamMap.get("target");

    if (path) {
      if (!target) {
        // Redirect ot new site
        window.location.href = path;
      } else {
        // Open with a target
        window.open(path, target);
      }
    } else {
    }

    // Promise will never resolve since user is redirected to another site
    return new Promise<void>(() => {});
  }
}
